import React from "react";

import Modal from "react-bootstrap/Modal";
import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";

import { Spinner } from "../LoadingContainer/Spinner";

export default function DeleteModal({
  entity,
  show,
  text,
  showText = true,
  isRemoving,
  handleClose,
  handleDelete,
}) {
  return (
    <Modal
      className="delete-modal"
      centered
      animation={false}
      fullscreen="md-down"
      show={show}
      onHide={handleClose}
      backdrop="static"
    >
      <Modal.Body>
        <div className="modal-body-heading">
          <h1 className="modal-body-heading-title">
            Are you sure you want to delete this {entity}?
          </h1>
          {text && <p>{text}</p>}
          {showText && <p>You will not be able to restore this action</p>}
        </div>
        <Stack className="btn-group-flex">
          <Button
            variant="outline-light"
            size="lg"
            className="btn-width text-danger"
            onClick={handleDelete}
            disabled={isRemoving}
          >
            {isRemoving ? <Spinner variant="dark" /> : "Delete"}
          </Button>
          <Button size="lg" onClick={handleClose}>
            Cancel
          </Button>
        </Stack>
      </Modal.Body>
    </Modal>
  );
}
